import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=f459902a&scoped=true"
import script from "./AppLoading.vue?vue&type=script&lang=js"
export * from "./AppLoading.vue?vue&type=script&lang=js"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=f459902a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f459902a",
  null
  
)

export default component.exports